import type { Plugin } from "vue";
import type { TAppConfig } from "~ui/@application/configs/config-schema.ts";

import { QueryClient, type QueryClientConfig, VueQueryPlugin } from "@tanstack/vue-query";

type TTanstackConfigurationPluginOptions = {
  config: TAppConfig;
  queryClient?: QueryClient;
  queryClientConfig?: QueryClientConfig;
};

function buildDefaultQueryClient(config: TAppConfig, options?: QueryClientConfig): QueryClient {
  return new QueryClient(options ?? buildDefaultQueryClientConfig(config));
}

function buildDefaultQueryClientConfig(config: TAppConfig): QueryClientConfig {
  return {
    defaultOptions: {
      mutations: {
        retry: 0,
        throwOnError: true,
      },
      queries: {
        retry: 0,
        throwOnError: true,
        staleTime: config.VITE_TANSTACK_GLOBAL_STALE_TIME,
        refetchOnMount: config.VITE_TANSTACK_REFETCH_ON_MOUNT,
      },
    },
  };
}

export const voltexploitTanstackConfigurationPlugin = {
  install(app, options: TTanstackConfigurationPluginOptions) {
    const { config, queryClientConfig = buildDefaultQueryClientConfig(options.config) } = options;

    const { queryClient = buildDefaultQueryClient(config, queryClientConfig) } = options;

    app.use(VueQueryPlugin, {
      queryClient: queryClient,
      queryClientConfig: queryClientConfig,
    });
  },
} satisfies Plugin;
